import { PropertyFilterParameters } from '../models/propertyFilterParameters';

/** filters of the public sold page, applied by the server: a missing list does not filter, an empty list matches nothing */
export class SoldPropertiesPageRequest {
  businessId!: string;
  page!: number;
  pageSize!: number;
  includeMarkers: boolean = false;
  propertyTypes?: { typeId: number, subTypeId?: number }[];
  states?: string[];
  saleTypeIds?: number[];
  propertyIds?: number[];
  beds?: number;
  baths?: number;
  garages?: number;
  areaFrom?: number;
  areaTo?: number;

  public setFilter(params: PropertyFilterParameters | undefined) {
    this.propertyTypes = params?.propertyTypes?.flatMap(pt => pt.subTypeList?.length
      ? pt.subTypeList.map(st => ({ typeId: pt.id, subTypeId: st.id }))
      : [{ typeId: pt.id }]);
    this.states = params?.states?.map(s => s.stateCode);
    this.saleTypeIds = params?.saleTypes?.map(st => st.id);
    this.propertyIds = params?.propertySearch?.propertyIds;
    const features = params?.propertyFeatures;
    this.beds = Number(features?.beds) || undefined;
    this.baths = Number(features?.baths) || undefined;
    this.garages = Number(features?.garages) || undefined;
    this.areaFrom = Number(features?.areaFrom) || undefined;
    this.areaTo = Number(features?.areaTo) || undefined;
  }
}
